
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanyRechargeClient, CompanyClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import { convertCurrency } from '@/utils'

@Component({
  name: 'CompanyRechargeEditor',
  components: {
  }
})
export default class extends BaseEditor {
  private companyList= [];
  private companyClient = new CompanyClient();
  public constructor() {
    super()
    this.client = new CompanyRechargeClient()
    this.data = { }
    this.rules = {
      companyId: [{ required: true, message: '车队为必选项', trigger: 'blur' }],
      amount: [{ required: true, message: '充值金额不能为空', trigger: 'blur' },
        { type: 'number', min: 0.01, max: 9999999, message: '充值金额必须在正常范围[0.01~9999999]', trigger: 'blur' }],
      discount: [
        { required: true, message: '折扣不能为空', trigger: 'blur' }
      ]
    }
  }

  get smalltoBIG(): string {
    return convertCurrency(this.data.amount)
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          discount: true
        },
        order: ['name']
      }
    })
  }

  public async reset() {
    this.data = {
      companyId: undefined,
      amount: undefined,
      discount: 1,
      description: undefined,
      status: 'waiting'
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'companyId',
      'amount',
      'discount',
      'description',
      'status'
    ])
    data.amount = Number(data.amount)
    data.discount = Number(data.discount)
    return this.clearData(data)
  }
}
